var finansudd = finansudd || {};

finansudd.socialShare = new function (selectors) {
    this.init = function (selectors) {
        selectors.click(function (e) {
            e.preventDefault();
            var $this = $(this),
                    url = $this.attr('href'),
                    name = "Something",
                    specs = "titlebar=no, status=no, scrollbars=no, menubar=no, location=no, width=600, height=550, top=200, left=400";

            var newWindow = window.open(url, name, specs);
        });
    };
};